import { useState } from 'react';
import { InputOTP } from '@components/InputOTP';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const InputOTPSection = () => {
  const [otpValue, setOtpValue] = useState('');
  const [otpValue4, setOtpValue4] = useState('');
  const [otpValueFilled, setOtpValueFilled] = useState('123456');

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Input OTP"
        description="One-time password input for verification codes. Supports 4-10 digits with auto-advance and paste support."
        figmaNodeId="232-2184"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Default (6 digits)</h3>
        <div className={styles.otpDemo}>
          <InputOTP value={otpValue} onChange={setOtpValue} onComplete={() => {}} />
        </div>
        <p className={styles.hint}>Current value: "{otpValue}"</p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>4 Digits</h3>
        <div className={styles.otpDemo}>
          <InputOTP value={otpValue4} onChange={setOtpValue4} length={4} onComplete={() => {}} />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Pre-filled</h3>
        <div className={styles.otpDemo}>
          <InputOTP value={otpValueFilled} onChange={setOtpValueFilled} />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Disabled</h3>
        <div className={styles.otpDemo}>
          <InputOTP value="123456" onChange={() => {}} disabled />
        </div>
      </div>
    </section>
  );
};
